import React from "react";
import useStartReveal from "../start/useStartReveal";
import "./ForPage.css";

/** Narrow SEO prose block (H2 + paragraphs). */
export default function ForProse({ id = "for-prose", title, paragraphs = [] }) {
  const ref = useStartReveal();
  return (
    <section id={id} className="st-section fr-prose-section" aria-labelledby={`${id}-title`}>
      <div className="st-container st-reveal" ref={ref}>
        <div className="fr-prose">
          <h2 id={`${id}-title`} className="st-h2">{title}</h2>
          {paragraphs.map((p) => (
            <p key={p}>{p}</p>
          ))}
        </div>
      </div>
    </section>
  );
}
